(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7715],{

/***/ 24250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/minus.1f12d65e.svg","height":24,"width":24});

/***/ }),

/***/ 86592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/plus.690dda76.svg","height":24,"width":24});

/***/ }),

/***/ 91619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/store/slices/category.ts
var category = __webpack_require__(10328);
;// CONCATENATED MODULE: ./src/utils/text-methods.ts
var toTitleCase = function(str) {
    return str.replace(/(\w*\W*|\w*)\s*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./src/components/category-wizzy/breadcrumb/breadcrumb.tsx






var CatgeoryBreadcrumb = function() {
    var ref;
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        "aria-label": "breadcrumb",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
            className: "breadcrumb",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "breadcrumb-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: "Home"
                    })
                }),
                categoryState.mapping.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "breadcrumb-item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/jewellery/category/".concat(item.slug),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: toTitleCase(item.name)
                            })
                        })
                    }, item.slug);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "breadcrumb-item active ms-2",
                    children: toTitleCase(((ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.name) || "")
                })
            ]
        })
    });
};
/* harmony default export */ var breadcrumb = (CatgeoryBreadcrumb);


/***/ }),

/***/ 73839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ filters; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(89936);
// EXTERNAL MODULE: ./src/store/slices/category.ts
var category = __webpack_require__(10328);
// EXTERNAL MODULE: ./src/styles/product_list.module.scss
var product_list_module = __webpack_require__(79356);
var product_list_module_default = /*#__PURE__*/__webpack_require__.n(product_list_module);
// EXTERNAL MODULE: ./src/utils/combineCategoryFilters.ts
var combineCategoryFilters = __webpack_require__(48825);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/components/category-wizzy/breadcrumb/breadcrumb.tsx + 1 modules
var breadcrumb = __webpack_require__(91619);
// EXTERNAL MODULE: ./src/components/category-wizzy/pagination-counter/pagination-counter.tsx
var pagination_counter = __webpack_require__(68556);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./src/hooks/useHover.ts

var useHover = function(ref, handleMouseOver, handleMouseOut) {
    (0,react.useEffect)(function() {
        var node = ref.current;
        if (node) {
            node.addEventListener("mouseover", handleMouseOver);
            node.addEventListener("mouseout", handleMouseOut);
            return function() {
                node.removeEventListener("mouseover", handleMouseOver);
                node.removeEventListener("mouseout", handleMouseOut);
            };
        }
    }, [
        handleMouseOut,
        handleMouseOver,
        ref
    ]);
};
/* harmony default export */ var hooks_useHover = (useHover);

;// CONCATENATED MODULE: ./src/hooks/useOnClickOutside.ts

var useOnClickOutside = function(ref, handler) {
    (0,react.useEffect)(function() {
        var listener = function(event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return function() {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [
        ref,
        handler
    ]);
};
/* harmony default export */ var hooks_useOnClickOutside = (useOnClickOutside);

// EXTERNAL MODULE: ./src/components/common/single-dropdown/single-dropdown.module.scss
var single_dropdown_module = __webpack_require__(38606);
var single_dropdown_module_default = /*#__PURE__*/__webpack_require__.n(single_dropdown_module);
;// CONCATENATED MODULE: ./src/components/common/single-dropdown/single-dropdown.tsx





var SingleDropdown = function(param) {
    var label = param.label, items = param.items, onChange = param.onChange, _showSelected = param.showSelected, showSelected = _showSelected === void 0 ? false : _showSelected;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(label), selectLabel = ref2[0], setSelectLabel = ref2[1];
    hooks_useHover(ref, function() {
        return setOpen(true);
    }, function() {
        return setOpen(false);
    });
    hooks_useOnClickOutside(ref, function() {
        return setOpen(false);
    });
    (0,react.useEffect)(function() {
        setSelectLabel(label);
    }, [
        label
    ]);
    var dropdownItemsTemplate = function() {
        var getTemplate = function(item) {
            var isChildren = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            role: "button",
                            "aria-label": "button",
                            className: isChildren ? "ps-3 ".concat((single_dropdown_module_default()).child) : "",
                            onClick: function() {
                                setOpen(false);
                                if (onChange) {
                                    onChange(item.value);
                                }
                                if (showSelected) {
                                    setSelectLabel(item.label);
                                }
                            },
                            children: item.label
                        })
                    }),
                    ((ref = item.children) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: item.children.map(function(v) {
                            return getTemplate(v, true);
                        })
                    })
                ]
            }, "".concat(item.label).concat(item.value));
        };
        return items.map(function(v) {
            return getTemplate(v);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (single_dropdown_module_default()).select,
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "pointer",
                    onClick: function() {
                        return setOpen(!open);
                    },
                    children: [
                        selectLabel,
                        open ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "bi bi-caret-up-fill"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "bi bi-caret-down-fill"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "".concat((single_dropdown_module_default()).dropdown, " ").concat(!open ? "d-none" : ""),
                    children: [
                        dropdownItemsTemplate(),
                        items.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            onClick: function() {
                                return setOpen(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                role: "button",
                                children: "No options"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var single_dropdown = (SingleDropdown);

;// CONCATENATED MODULE: ./src/components/category-wizzy/filters/collection-filter/collection-filter.tsx







var CollectionFilter = function() {
    var router = (0,next_router.useRouter)();
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), filterCategories = ref[0], setFilterCategories = ref[1];
    react.useEffect(function() {
        var ref, ref1;
        var values = ((ref1 = categoryState === null || categoryState === void 0 ? void 0 : (ref = categoryState.facets) === null || ref === void 0 ? void 0 : ref.find(function(x) {
            return x.key == "categories";
        })) === null || ref1 === void 0 ? void 0 : ref1.data) || [];
        if (router.route == "/jewellery") {
            setFilterCategories([]);
        } else {
            setFilterCategories(values.filter(function(v) {
                var ref;
                return v.data.parentId == ((ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.id);
            }).map(function(v) {
                var ref;
                return {
                    label: "".concat(v.label, " (").concat(v.count, ")"),
                    value: (ref = v.data) === null || ref === void 0 ? void 0 : ref.url
                };
            }));
        }
    }, [
        categoryState,
        router.route
    ]);
    if (filterCategories.length == 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(single_dropdown, {
        label: "CATEGORIES",
        items: filterCategories,
        onChange: function(value) {
            return router.push({
                pathname: "/jewellery/category/".concat(value.split("/jewellery/category/")[1])
            });
        }
    });
};
/* harmony default export */ var collection_filter = (CollectionFilter);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/common/checkbox-dropdown/checkbox-dropdown.module.scss
var checkbox_dropdown_module = __webpack_require__(91920);
var checkbox_dropdown_module_default = /*#__PURE__*/__webpack_require__.n(checkbox_dropdown_module);
;// CONCATENATED MODULE: ./src/components/common/checkbox-dropdown/checkbox-dropdown.tsx






var CheckboxDropdown = function(param) {
    var label = param.label, items = param.items, onChange = param.onChange, prevSelected = param.selected;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(prevSelected || []), selected = ref2[0], setSelected = ref2[1];
    hooks_useHover(ref, function() {
        return setOpen(true);
    }, function() {
        return setOpen(false);
    });
    hooks_useOnClickOutside(ref, function() {
        return setOpen(false);
    });
    (0,react.useEffect)(function() {
        setSelected(prevSelected || []);
    }, [
        prevSelected
    ]);
    var checkboxChange = function(e) {
        var newValues = [];
        if (e.target.checked) {
            newValues = (0,_to_consumable_array/* default */.Z)(selected).concat([
                e.target.value
            ]);
        } else {
            newValues = selected.filter(function(v) {
                return v != e.target.value;
            });
        }
        setSelected(newValues);
        if (onChange) {
            onChange(newValues);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (checkbox_dropdown_module_default()).select,
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    onClick: function() {
                        return setOpen(!open);
                    },
                    children: [
                        label,
                        open ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "bi bi-caret-up-fill"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "bi bi-caret-down-fill"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "".concat((checkbox_dropdown_module_default()).dropdown, " ").concat(!open ? "d-none" : ""),
                    children: [
                        items.map(function(v, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    "aria-label": "checkbox",
                                    role: "button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "form-check m-0 min-h",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: "form-check-input input-filter-check",
                                                type: "checkbox",
                                                id: v.value,
                                                value: v.value,
                                                onChange: checkboxChange,
                                                checked: selected.includes(v.value)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: "form-check-label",
                                                htmlFor: v.value,
                                                children: v.label
                                            })
                                        ]
                                    })
                                })
                            }, v.value);
                        }),
                        items.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            onClick: function() {
                                return setOpen(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-label": "No options",
                                role: "button",
                                children: "No options"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var checkbox_dropdown = (CheckboxDropdown);

;// CONCATENATED MODULE: ./src/components/category-wizzy/filters/metal-filter/metal-filter.tsx









var MetalFilter = function(param) {
    var isSearch = param.isSearch;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    var dropdownChange = function(value) {
        var ref;
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    metal: value
                }))), {
                    q: router.query.q,
                    try_it_online: router.query.try_it_online
                })
            }, undefined, {
                shallow: true
            });
            return;
        }
        router.replace({
            pathname: "/jewellery/category/[category]",
            query: (0,_object_spread/* default */.Z)({
                category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
            }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                metal: value
            })))
        }, undefined, {
            shallow: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dropdown, {
        label: "METAL",
        items: (ref1 = categoryState === null || categoryState === void 0 ? void 0 : (ref = categoryState.facets) === null || ref === void 0 ? void 0 : ref.find(function(x) {
            return x.key == "purity";
        })) === null || ref1 === void 0 ? void 0 : ref1.data.map(function(v) {
            return {
                label: "".concat(v.label, " (").concat(v.count, ")"),
                value: v.key
            };
        }),
        onChange: dropdownChange,
        selected: typeof router.query.metal == "string" ? [
            router.query.metal
        ] : router.query.metal
    });
};
/* harmony default export */ var metal_filter = (MetalFilter);

;// CONCATENATED MODULE: ./src/components/category-wizzy/filters/price-filter/price-filter.tsx









var PriceFilter = function(param) {
    var isSearch = param.isSearch;
    var router = (0,next_router.useRouter)();
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    var priceFilters = [
        {
            label: "Below AED 10,000",
            value: {
                max: 10000
            }
        },
        {
            label: "AED 10,000 - AED 20,000",
            value: {
                min: 10000,
                max: 20000
            }
        },
        {
            label: "AED 20,000 - AED 30,000",
            value: {
                min: 20000,
                max: 30000
            }
        },
        {
            label: "AED 30,000 - AED 40,000",
            value: {
                min: 30000,
                max: 40000
            }
        },
        {
            label: "AED 40,000 - AED 50,000",
            value: {
                min: 40000,
                max: 50000
            }
        },
        {
            label: "AED 50,000 and Above",
            value: {
                min: 50000
            }
        }, 
    ];
    var priceFilterChange = function(value) {
        var ref;
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    priceMin: value.min,
                    priceMax: value.max
                }))), {
                    q: router.query.q,
                    try_it_online: router.query.try_it_online
                })
            }, undefined, {
                shallow: true
            });
            return;
        }
        router.replace({
            pathname: "/jewellery/category/[category]",
            query: (0,_object_spread/* default */.Z)({
                category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
            }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                priceMin: value.min,
                priceMax: value.max
            })))
        }, undefined, {
            shallow: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(single_dropdown, {
        label: "PRICE",
        items: priceFilters,
        onChange: priceFilterChange
    });
};
/* harmony default export */ var price_filter = (PriceFilter);

;// CONCATENATED MODULE: ./src/components/category-wizzy/filters/sort-filter/sort-filter.tsx









var SortFilter = function(param) {
    var isSearch = param.isSearch;
    var router = (0,next_router.useRouter)();
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    var sortFilters = [
        {
            label: "Relevance",
            value: ""
        },
        {
            label: "Price: Low to High",
            value: "price-asc"
        },
        {
            label: "Price: High to Low",
            value: "price-desc"
        }, 
    ];
    var sortFilterChange = function(value) {
        var ref;
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    sort: value
                }))), {
                    q: router.query.q,
                    try_it_online: router.query.try_it_online
                })
            }, undefined, {
                shallow: true
            });
            return;
        }
        router.replace({
            pathname: "/jewellery/category/[category]",
            query: (0,_object_spread/* default */.Z)({
                category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
            }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                sort: value
            })))
        }, undefined, {
            shallow: true
        });
    };
    var label = (0,react.useMemo)(function() {
        var ref;
        return ((ref = sortFilters.find(function(v) {
            return v.value == (router.query.sort || "");
        })) === null || ref === void 0 ? void 0 : ref.label) || "Relevance";
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router.query.sort
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(single_dropdown, {
        label: label,
        items: sortFilters,
        onChange: sortFilterChange,
        showSelected: true
    });
};
/* harmony default export */ var sort_filter = (SortFilter);

;// CONCATENATED MODULE: ./src/components/category-wizzy/filters/occasion-filter/occasion-filter.tsx









var OccasionFilter = function(param) {
    var isSearch = param.isSearch;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    var dropdownChange = function(value) {
        var ref;
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    occasion: value
                }))), {
                    q: router.query.q,
                    try_it_online: router.query.try_it_online
                })
            }, undefined, {
                shallow: true
            });
            return;
        }
        router.replace({
            pathname: "/jewellery/category/[category]",
            query: (0,_object_spread/* default */.Z)({
                category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
            }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                occasion: value
            })))
        }, undefined, {
            shallow: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dropdown, {
        label: "OCCASION",
        items: (ref1 = categoryState === null || categoryState === void 0 ? void 0 : (ref = categoryState.facets) === null || ref === void 0 ? void 0 : ref.find(function(x) {
            return x.key == "occasions";
        })) === null || ref1 === void 0 ? void 0 : ref1.data.map(function(v) {
            return {
                label: "".concat(v.label, " (").concat(v.count, ")"),
                value: v.key
            };
        }),
        onChange: dropdownChange,
        selected: typeof router.query.occasion == "string" ? [
            router.query.occasion
        ] : router.query.occasion
    });
};
/* harmony default export */ var occasion_filter = (OccasionFilter);

;// CONCATENATED MODULE: ./src/components/category-wizzy/filters/filters.tsx


















var CatgeoryFiltersWizzy = function() {
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,store/* useAppDispatch */.T)();
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    var ref4 = (0,react.useState)(false), showFilter = ref4[0], setShowFilter = ref4[1];
    var ref5 = (0,react.useState)(false), showSort = ref5[0], setShowSort = ref5[1];
    var ref6 = (0,react.useState)(false), isSearch = ref6[0], setIsSearch = ref6[1];
    (0,react.useEffect)(function() {
        if (router.route == "/jewellery") {
            setIsSearch(true);
        }
    }, [
        router.route
    ]);
    (0,react.useEffect)(function() {
        if (!isSearch && categoryState.data) {
            dispatch((0,category/* fetchCategoryMappingById */.qg)(categoryState.data.id));
        }
    }, [
        categoryState.data,
        dispatch,
        isSearch
    ]);
    var fastDeliveryChange = function(event) {
        var ref;
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    fastDelivery: event.target.checked
                }))), {
                    q: router.query.q
                })
            }, undefined, {
                shallow: true
            });
            return;
        }
        router.replace({
            pathname: "/jewellery/category/[category]",
            query: (0,_object_spread/* default */.Z)({
                category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
            }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                fastDelivery: event.target.checked
            })))
        }, undefined, {
            shallow: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row mb-0 mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12",
                    children: [
                        !isSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {}),
                        isSearch && router.query.q && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Search results for '",
                                router.query.q,
                                "'"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (product_list_module_default()).desktop_filter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-100 display-fl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (product_list_module_default()).filter_section,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Filter By:"
                                        }),
                                        !!(categoryState === null || categoryState === void 0 ? void 0 : (ref = categoryState.facets) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
                                            return v.key == "categories";
                                        }).length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(collection_filter, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(price_filter, {
                                            isSearch: isSearch
                                        }),
                                        !!(categoryState === null || categoryState === void 0 ? void 0 : (ref1 = categoryState.facets) === null || ref1 === void 0 ? void 0 : ref1.filter(function(v) {
                                            return v.key == "purity";
                                        }).length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(metal_filter, {
                                            isSearch: isSearch
                                        }),
                                        !!(categoryState === null || categoryState === void 0 ? void 0 : (ref2 = categoryState.facets) === null || ref2 === void 0 ? void 0 : ref2.filter(function(v) {
                                            return v.key == "occasions";
                                        }).length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(occasion_filter, {
                                            isSearch: isSearch
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-9",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-1 mt-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination_counter/* default */.Z, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (product_list_module_default()).filter_section2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Sort By:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sort_filter, {
                                            isSearch: isSearch
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cleafix"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (product_list_module_default()).mobile_filter,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                "aria-label": "Filter By",
                                role: "button",
                                onClick: function() {
                                    return setShowFilter(!showFilter);
                                },
                                children: [
                                    "Filter By",
                                    !showFilter ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: __webpack_require__(86592),
                                        alt: ""
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: __webpack_require__(24250),
                                        alt: ""
                                    })
                                ]
                            })
                        }),
                        showFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (product_list_module_default()).filter_section,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Filter By:"
                                    }),
                                    !isSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(collection_filter, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(price_filter, {
                                        isSearch: isSearch
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(metal_filter, {
                                        isSearch: isSearch
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(occasion_filter, {
                                        isSearch: isSearch
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 mt-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                "aria-label": "Sort By",
                                role: "button",
                                onClick: function() {
                                    return setShowSort(!showSort);
                                },
                                children: [
                                    "Sort By",
                                    !showSort ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: __webpack_require__(86592),
                                        alt: ""
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: __webpack_require__(24250),
                                        alt: ""
                                    })
                                ]
                            })
                        }),
                        showSort && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (product_list_module_default()).filter_section1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Sort By:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sort_filter, {
                                    isSearch: isSearch
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-12",
                            children: ((ref3 = categoryState.products) === null || ref3 === void 0 ? void 0 : ref3.data) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mb-1 mt-3",
                                children: [
                                    "Showing 1 -",
                                    " ",
                                    categoryState.products.size * (categoryState.products.page - 1) + categoryState.products.data.length,
                                    " ",
                                    "of ",
                                    categoryState.products.totalRecords
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var filters = (CatgeoryFiltersWizzy);


/***/ }),

/***/ 68556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _store_slices_category__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10328);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);




var PaginationCounterWizzy = function() {
    var ref, ref1;
    var categoryState = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_store_slices_category__WEBPACK_IMPORTED_MODULE_1__/* .selectCategory */ .uY);
    if ((ref = categoryState.products) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1.length) {
        var ref2, ref3, ref4;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                "Showing 1 - ",
                (ref2 = categoryState.products) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.result) === null || ref3 === void 0 ? void 0 : ref3.length,
                " of",
                " ",
                (ref4 = categoryState.products) === null || ref4 === void 0 ? void 0 : ref4.total
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (PaginationCounterWizzy);


/***/ }),

/***/ 17751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ products_list; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(89936);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Accordion.js + 7 modules
var Accordion = __webpack_require__(5607);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./src/components/product-card/product-card-skeleton.tsx
var product_card_skeleton = __webpack_require__(35098);
// EXTERNAL MODULE: ./src/store/slices/category.ts
var category = __webpack_require__(10328);
// EXTERNAL MODULE: ./src/styles/product_list.module.scss
var product_list_module = __webpack_require__(79356);
var product_list_module_default = /*#__PURE__*/__webpack_require__.n(product_list_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/components/category-wizzy/breadcrumb/breadcrumb.tsx + 1 modules
var breadcrumb = __webpack_require__(91619);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/combineCategoryFilters.ts
var combineCategoryFilters = __webpack_require__(48825);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/store/slices/auth.ts
var auth = __webpack_require__(40034);
// EXTERNAL MODULE: ./src/store/slices/cart.ts
var cart = __webpack_require__(45066);
// EXTERNAL MODULE: ./node_modules/@tippyjs/react/dist/tippy-react.esm.js + 3 modules
var tippy_react_esm = __webpack_require__(81246);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./src/components/common/currency-inr.tsx
var currency_inr = __webpack_require__(76630);
// EXTERNAL MODULE: ./src/components/common/loading-spinner.tsx + 1 modules
var loading_spinner = __webpack_require__(74043);
// EXTERNAL MODULE: ./src/components/common/loading-spinner-small.tsx + 1 modules
var loading_spinner_small = __webpack_require__(66091);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(92814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-regular-svg-icons/index.es.js
var free_regular_svg_icons_index_es = __webpack_require__(56024);
// EXTERNAL MODULE: ./src/store/slices/wishlist.ts
var wishlist = __webpack_require__(78271);
// EXTERNAL MODULE: ./src/lib/fpixel.ts
var fpixel = __webpack_require__(50634);
// EXTERNAL MODULE: ./src/lib/tryOnTracking.ts
var tryOnTracking = __webpack_require__(68763);
// EXTERNAL MODULE: ./src/lib/syte.ts
var syte = __webpack_require__(68320);
// EXTERNAL MODULE: ./src/image-loaders/s3-image-loader.ts
var s3_image_loader = __webpack_require__(78513);
;// CONCATENATED MODULE: ./src/components/product-card-wizzy/product-card.tsx



























var ProductCardWizzy = function(param) {
    var product = param.product;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref13 = (0,react.useState)(false), cartAddLoading = ref13[0], setCartAddLoading = ref13[1];
    var ref14 = (0,react.useState)(false), cartRemoveLoading = ref14[0], setCartRemoveLoading = ref14[1];
    var ref15 = (0,react.useState)(false), wishlistActionLoading = ref15[0], setwishlistActionLoading = ref15[1];
    var ref16 = (0,react.useState)({
        type: "",
        id: ""
    }), actionData = ref16[0], setActionData = ref16[1];
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var wishlistState = (0,es/* useSelector */.v9)(wishlist/* selectWishlist */.jq);
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var actionInProgress = (0,react.useRef)(false);
    var ref17 = (0,react.useState)(false), tryOnAddToCart = ref17[0], setTryOnAddToCart = ref17[1];
    var ref18 = (0,react.useState)(false), tryOnRemoveFromCart = ref18[0], setTryOnRemoveFromCart = ref18[1];
    var priceId = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        return (ref2 = (ref1 = (ref = product.attributes) === null || ref === void 0 ? void 0 : ref.find(function(v) {
            return v.id === "price_id";
        })) === null || ref1 === void 0 ? void 0 : ref1.values[0]) === null || ref2 === void 0 ? void 0 : ref2.value[0];
    }, [
        product.attributes
    ]);
    var cartItem = (0,react.useMemo)(function() {
        return cartState.items.find(function(v) {
            return v.identifier == (priceId || 0).toString();
        }) || null;
    }, [
        cartState.items,
        priceId
    ]);
    var wishlistItem = (0,react.useMemo)(function() {
        return wishlistState.items.find(function(v) {
            return v.id == product.id;
        }) || null;
    }, [
        wishlistState.items,
        product.id
    ]);
    var addToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!cartAddLoading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (authState.user) {
                            _ctx.next = 7;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        setActionData({
                            type: "cart",
                            id: priceId
                        });
                        sessionStorage.setItem("add-to-cart-or-wishlist-id", priceId);
                        return _ctx.abrupt("return");
                    case 7:
                        setCartAddLoading(true);
                        _ctx.prev = 8;
                        ;
                        _ctx.next = 12;
                        return http_client/* default.post */.Z.post(endpoints/* default.cart.add */.Z.cart.add(), {
                            is_solitaire: false,
                            type: "product",
                            identifier: priceId
                        });
                    case 12:
                        _ctx.next = 14;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 14:
                        (0,react_toastify_esm/* toast */.Am)("Item added in cart", {
                            type: "success",
                            toastId: "cart-add-success"
                        });
                        (0,fpixel/* fbqTrackEvent */.dK)("AddToCart", {
                            content_type: "product",
                            content_ids: [
                                product.sku[0]
                            ]
                        });
                        if (product.categories && product.categories.length) {
                            window.dataLayer.push({
                                ecommerce: null
                            });
                            window.dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    currency: "AED",
                                    value: product.sellingPrice,
                                    items: [
                                        {
                                            item_id: product.sku[0],
                                            item_name: product.title,
                                            item_category: (0,_to_consumable_array/* default */.Z)(product.categories).reverse()[0].name,
                                            price: product.sellingPrice,
                                            quantity: 1
                                        }, 
                                    ]
                                }
                            });
                        }
                        (0,syte/* syteTrackEvent */.l)({
                            name: "products_added_to_cart",
                            tag: "ecommerce",
                            osh_id: (ref = authState.user) === null || ref === void 0 ? void 0 : ref.uuid,
                            products: [
                                {
                                    sku: product.sku[0],
                                    price: product.sellingPrice,
                                    quantity: 1
                                }, 
                            ]
                        });
                        _ctx.next = 22;
                        break;
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](8);
                    case 22:
                        setCartAddLoading(false);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    20
                ]
            ]);
        }));
        return function addToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (tryOnAddToCart) {
            setTryOnAddToCart(false);
            addToCart();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tryOnAddToCart
    ]);
    var removeFromCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var requireConfirmation, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        requireConfirmation = _args.length > 0 && _args[0] !== void 0 ? _args[0] : true;
                        if (!requireConfirmation) {
                            _ctx.next = 4;
                            break;
                        }
                        if (confirm("Are you sure you want to remove this product from cart?")) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        setCartRemoveLoading(true);
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return http_client/* default.delete */.Z["delete"](endpoints/* default.cart.remove */.Z.cart.remove(cartItem === null || cartItem === void 0 ? void 0 : cartItem.id));
                    case 8:
                        _ctx.next = 10;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 10:
                        (0,react_toastify_esm/* toast */.Am)("Item removed from cart", {
                            type: "info",
                            toastId: "cart-remove-success"
                        });
                        if (product.categories && product.categories.length) {
                            window.dataLayer.push({
                                ecommerce: null
                            });
                            window.dataLayer.push({
                                event: "remove_from_cart",
                                ecommerce: {
                                    currency: "AED",
                                    value: product.discount ? product.discount.price : product.price,
                                    items: [
                                        {
                                            item_id: product.sku[0],
                                            item_name: product.title,
                                            item_category: (0,_to_consumable_array/* default */.Z)(product.categories).reverse()[0].name,
                                            price: product.discount ? product.discount.price : product.price,
                                            quantity: 1
                                        }, 
                                    ]
                                }
                            });
                        }
                        _ctx.next = 17;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](5);
                        ;
                    case 17:
                        setCartRemoveLoading(false);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    14
                ]
            ]);
        }));
        return function removeFromCart() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (tryOnRemoveFromCart) {
            setTryOnRemoveFromCart(false);
            removeFromCart(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tryOnRemoveFromCart
    ]);
    var openTryOn = function() {
        if (window.initMirrarUI && "6acc6370-ec65-4345-93ad-5f652979e561") {
            (0,tryOnTracking/* initTryOnEventListener */.K)(function(name, data) {
                if (name == "add-to-cart") {
                    if (data.productCode == String(product.sku[0]).toUpperCase()) {
                        setTryOnAddToCart(true);
                    }
                }
                if (name == "ProductRemoveFromCart") {
                    if (data.productCode == String(product.sku[0]).toUpperCase()) {
                        setTryOnRemoveFromCart(true);
                    }
                }
            });
            window.initMirrarUI(String(product.sku[0]).toUpperCase(), {
                brandId: "6acc6370-ec65-4345-93ad-5f652979e561"
            });
            if (product.categories && product.categories.length) {
                window.gtag("event", "tryon-button-click", {
                    event_category: "mirrar-internal-event",
                    event_label: "".concat((0,_to_consumable_array/* default */.Z)(product.categories).reverse()[0].name, "/").concat(product.sku[0], "/").concat(product.discount ? product.discount.total : product.price)
                });
            }
        }
    };
    var addToWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!wishlistActionLoading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (authState.user) {
                            _ctx.next = 7;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        sessionStorage.setItem("add-to-cart-or-wishlist-id", product.groupId ? product.groupId : product.id);
                        setActionData({
                            type: "wishlist",
                            id: product.groupId ? product.groupId : product.id
                        });
                        return _ctx.abrupt("return");
                    case 7:
                        setwishlistActionLoading(true);
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return http_client/* default.post */.Z.post(endpoints/* default.wishlist.add */.Z.wishlist.add(), {
                            product_id: product.groupId ? product.groupId : product.id,
                            user_id: authState.user.id
                        });
                    case 11:
                        _ctx.next = 13;
                        return dispatch((0,wishlist/* fetchWishlistItems */.nf)(authState.user.id));
                    case 13:
                        (0,react_toastify_esm/* toast */.Am)("Item added in wishlist", {
                            type: "success",
                            toastId: "withlist-add-success"
                        });
                        (0,fpixel/* fbqTrackEvent */.dK)("AddToWishlist", {
                            content_type: "product",
                            content_ids: [
                                product.sku[0]
                            ]
                        });
                        _ctx.next = 19;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](8);
                    case 19:
                        setwishlistActionLoading(false);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    17
                ]
            ]);
        }));
        return function addToWishlist() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeFromWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!wishlistActionLoading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (confirm("Are you sure you want to remove this product from wishlist?")) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (authState.user) {
                            _ctx.next = 7;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        return _ctx.abrupt("return");
                    case 7:
                        setwishlistActionLoading(true);
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return http_client/* default.post */.Z.post(endpoints/* default.wishlist.remove */.Z.wishlist.remove(), {
                            product_id: product.id,
                            user_id: authState.user.id
                        });
                    case 11:
                        _ctx.next = 13;
                        return dispatch((0,wishlist/* fetchWishlistItems */.nf)(authState.user.id));
                    case 13:
                        (0,react_toastify_esm/* toast */.Am)("Item removed from wishlist", {
                            type: "success",
                            toastId: "withlist-remove-success"
                        });
                        _ctx.next = 18;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](8);
                    case 18:
                        setwishlistActionLoading(false);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    16
                ]
            ]);
        }));
        return function removeFromWishlist() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var handleAction = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!actionInProgress.current) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            if (!(actionData.id && authState.user)) {
                                _ctx.next = 23;
                                break;
                            }
                            actionInProgress.current = true;
                            _ctx.prev = 4;
                            if (!(actionData.type === "cart")) {
                                _ctx.next = 10;
                                break;
                            }
                            _ctx.next = 8;
                            return addToCart();
                        case 8:
                            _ctx.next = 13;
                            break;
                        case 10:
                            if (!(actionData.type === "wishlist")) {
                                _ctx.next = 13;
                                break;
                            }
                            _ctx.next = 13;
                            return addToWishlist();
                        case 13:
                            _ctx.next = 18;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](4);
                            ;
                        case 18:
                            _ctx.prev = 18;
                            setActionData({
                                type: "",
                                id: ""
                            });
                            sessionStorage.removeItem("add-to-cart-or-wishlist-id");
                            actionInProgress.current = false;
                            return _ctx.finish(18);
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        15,
                        18,
                        23
                    ]
                ]);
            }));
            return function handleAction() {
                return _ref.apply(this, arguments);
            };
        }();
        var cart_id = sessionStorage.getItem("add-to-cart-or-wishlist-id");
        if ("".concat(actionData === null || actionData === void 0 ? void 0 : actionData.id) === cart_id && authState.user) {
            handleAction();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        authState,
        actionData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (product_list_module_default()).product,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (product_list_module_default()).pad_10,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (product_list_module_default()).products_text_top,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (product_list_module_default()).product_top_left,
                            children: [
                                !!((ref2 = (ref1 = (ref = product.attributes) === null || ref === void 0 ? void 0 : ref.find(function(v) {
                                    return v.id === "tags";
                                })) === null || ref1 === void 0 ? void 0 : ref1.values[0]) === null || ref2 === void 0 ? void 0 : ref2.value[0]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (product_list_module_default()).new_arrival,
                                    children: (ref5 = (ref4 = (ref3 = product.attributes) === null || ref3 === void 0 ? void 0 : ref3.find(function(v) {
                                        return v.id === "tags";
                                    })) === null || ref4 === void 0 ? void 0 : ref4.values[0]) === null || ref5 === void 0 ? void 0 : ref5.value[0]
                                }),
                                !!((ref6 = product.attributes) === null || ref6 === void 0 ? void 0 : ref6.find(function(v) {
                                    return v.id === "deal_of_the_day";
                                })) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (product_list_module_default()).trending,
                                    children: "Deal of The Day"
                                }),
                                !!((ref9 = (ref8 = (ref7 = product.attributes) === null || ref7 === void 0 ? void 0 : ref7.find(function(v) {
                                    return v.id === "discount_name";
                                })) === null || ref8 === void 0 ? void 0 : ref8.values[0]) === null || ref9 === void 0 ? void 0 : ref9.value[0]) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (product_list_module_default()).discount,
                                        children: (ref12 = (ref11 = (ref10 = product.attributes) === null || ref10 === void 0 ? void 0 : ref10.find(function(v) {
                                            return v.id === "discount_name";
                                        })) === null || ref11 === void 0 ? void 0 : ref11.values[0]) === null || ref12 === void 0 ? void 0 : ref12.value[0]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (product_list_module_default()).cart_top,
                            children: [
                                wishlistActionLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        position: "relative",
                                        top: -6
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner_small/* default */.Z, {})
                                }),
                                !wishlistActionLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: wishlistItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                        content: "Wishlisted",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "pointer",
                                            onClick: removeFromWishlist,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons_index_es/* faHeart */.m6i,
                                                width: 20,
                                                color: "#FF1933",
                                                style: {
                                                    position: "relative",
                                                    top: -8
                                                }
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                        content: "Add To Wishlist",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "pointer",
                                            onClick: addToWishlist,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_regular_svg_icons_index_es/* faHeart */.m6i,
                                                width: 20,
                                                color: "#FF1933",
                                                style: {
                                                    position: "relative",
                                                    top: -8
                                                }
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: product.url,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (product_list_module_default()).product_image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: product.mainImage,
                                className: (product_list_module_default()).img_fluid,
                                alt: product.name,
                                width: 2500,
                                height: 2500,
                                sizes: "(max-width: 479px) 148px, (max-width: 640px) 200px, (max-width: 991px) 318px, (max-width: 1199px) 200px, (max-width: 1600px) 245px, (max-width: 1920px) 50vw, 100vw",
                                loader: s3_image_loader/* S3ImageLoader */.V
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (product_list_module_default()).product_text_d,
                    children: product.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (product_list_module_default()).price_cart,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (product_list_module_default()).price1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                        value: product.sellingPrice
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                product.sellingPrice !== product.price && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (product_list_module_default()).price2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                            value: product.price
                                        })
                                    })
                                })
                            ]
                        }),
                        !cartItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                cartAddLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {}),
                                !cartAddLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                    content: "Add To Cart",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "".concat((product_list_module_default()).details, " pointer"),
                                        onClick: addToCart,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "bi bi-cart-plus"
                                        })
                                    })
                                })
                            ]
                        }),
                        cartItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                cartRemoveLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {}),
                                !cartRemoveLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                    content: "Remove From Cart",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "".concat((product_list_module_default()).details, " pointer"),
                                        onClick: function() {
                                            return removeFromCart();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "bi bi-cart-dash-fill"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var product_card = (ProductCardWizzy);

// EXTERNAL MODULE: ./src/components/category-wizzy/pagination-counter/pagination-counter.tsx
var pagination_counter = __webpack_require__(68556);
;// CONCATENATED MODULE: ./src/components/category-wizzy/products-list/products-list.tsx


















var CategoryProductsListWizzy = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    ;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var ref15 = (0,react.useState)(false), isSearch = ref15[0], setIsSearch = ref15[1];
    var ref16 = (0,react.useState)(false), loadingMore = ref16[0], setLoadingMore = ref16[1];
    var sentinelRef = (0,react.useRef)(null);
    var apiFilterQuery = (0,react.useCallback)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        var filter = {
            page: 1,
            productsCount: 20,
            currency: "",
            getAllVariants: "false",
            showOOSProductsInOrder: "false",
            attributeFacetValuesLimit: 20,
            attributes: {}
        };
        if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.fastDelivery) {
            filter.attributes["fast_delivery"] = [
                "true"
            ];
        }
        if ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.try_it_online) {
            filter.attributes["try_online"] = [
                "true"
            ];
        }
        if ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.metal) === null || ref3 === void 0 ? void 0 : ref3.length) {
            var ref10, ref11, ref12;
            filter.attributes["purity"] = typeof ((ref10 = router.query) === null || ref10 === void 0 ? void 0 : ref10.metal) !== "string" ? (ref11 = router.query) === null || ref11 === void 0 ? void 0 : ref11.metal : [
                (ref12 = router.query) === null || ref12 === void 0 ? void 0 : ref12.metal
            ];
        }
        if ((ref4 = router.query) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.occasion) === null || ref5 === void 0 ? void 0 : ref5.length) {
            var ref13, ref14, ref15;
            filter.attributes["occasions"] = typeof ((ref13 = router.query) === null || ref13 === void 0 ? void 0 : ref13.occasion) !== "string" ? (ref14 = router.query) === null || ref14 === void 0 ? void 0 : ref14.occasion : [
                (ref15 = router.query) === null || ref15 === void 0 ? void 0 : ref15.occasion
            ];
        }
        if (((ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.priceMin) || ((ref7 = router.query) === null || ref7 === void 0 ? void 0 : ref7.priceMax)) {
            var ref16, ref17;
            filter.sellingPrice = [
                {
                    lte: ((ref16 = router.query) === null || ref16 === void 0 ? void 0 : ref16.priceMax) || null,
                    gte: ((ref17 = router.query) === null || ref17 === void 0 ? void 0 : ref17.priceMin) || 0
                }, 
            ];
        }
        if ((ref8 = router.query) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sort) === null || ref9 === void 0 ? void 0 : ref9.length) {
            var ref18;
            if (((ref18 = router.query) === null || ref18 === void 0 ? void 0 : ref18.sort) == "price-asc") {
                filter.sort = [
                    {
                        field: "sellingPrice",
                        order: "asc",
                        isForVariation: "false",
                        isForParent: "true"
                    }, 
                ];
            } else {
                filter.sort = [
                    {
                        field: "sellingPrice",
                        order: "desc",
                        isForParent: "true",
                        isForVariation: "false"
                    },
                    {
                        field: "sellingPrice",
                        order: "asc",
                        isForVariation: "true",
                        isForParent: "false"
                    }, 
                ];
            }
        } else {
            if (router.route == "/jewellery") {
                var ref19;
                if (((ref19 = router.query) === null || ref19 === void 0 ? void 0 : ref19.try_it_online) == "yes") {
                    filter.sort = [
                        {
                            field: "priority:float",
                            order: "asc"
                        },
                        {
                            field: "sellingPrice",
                            order: "asc"
                        }, 
                    ];
                } else {
                    filter.sort = [
                        {
                            field: "relevance",
                            order: "asc"
                        },
                        {
                            field: "sellingPrice",
                            order: "asc"
                        }, 
                    ];
                }
            } else {
                filter.sort = [
                    {
                        field: "priority:float",
                        order: "asc"
                    },
                    {
                        field: "relevance",
                        order: "asc"
                    }, 
                ];
            }
        }
        return filter;
    }, [
        router.query,
        router.route
    ]);
    var loadMore = (0,react.useCallback)(function() {
        var ref, ref1, ref2, ref3;
        if (!categoryState.products || loadingMore) return;
        if (((ref = categoryState.products.result) === null || ref === void 0 ? void 0 : ref.length) >= categoryState.products.total) return;
        setLoadingMore(true);
        var nextPage = +((ref1 = categoryState.products.filters) === null || ref1 === void 0 ? void 0 : ref1.page) + 1;
        var promise = isSearch ? dispatch((0,category/* fetchMoreSearchProductsByWizzy */.Rz)({
            query: {
                page: nextPage,
                search: router.query.q,
                filters: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, apiFilterQuery()), {
                    q: router.query.q,
                    searchedKey: (ref2 = categoryState.products.filters) === null || ref2 === void 0 ? void 0 : ref2.searchedKey,
                    page: nextPage
                })
            }
        })) : categoryState.data ? dispatch((0,category/* fetchLoadMoreCategoryProductsByIdWizzy */.K4)({
            id: categoryState.data.id,
            query: {
                page: nextPage,
                filters: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, apiFilterQuery()), {
                    categories: [
                        String((ref3 = categoryState.data) === null || ref3 === void 0 ? void 0 : ref3.id)
                    ],
                    q: null,
                    page: nextPage
                })
            }
        })) : null;
        if (promise) {
            promise.finally(function() {
                setLoadingMore(false);
            });
        } else {
            setLoadingMore(false);
        }
    }, [
        categoryState.products,
        categoryState.data,
        loadingMore,
        isSearch,
        router.query,
        dispatch,
        apiFilterQuery
    ]);
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(entries) {
            var first = entries[0];
            if (first.isIntersecting) {
                loadMore();
            }
        }, {
            threshold: 0.1
        });
        var currentSentinel = sentinelRef.current;
        if (currentSentinel) {
            observer.observe(currentSentinel);
        }
        return function() {
            if (currentSentinel) {
                observer.unobserve(currentSentinel);
            }
        };
    }, [
        loadMore
    ]);
    (0,react.useEffect)(function() {
        if (categoryState.data) {
            if (!router.query.sort && [
                "bangle-utsav-collection-2023"
            ].includes(categoryState.data.slug)) {
                var ref;
                router.replace({
                    pathname: "/jewellery/category/[category]",
                    query: (0,_object_spread/* default */.Z)({
                        category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
                    }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                        sort: "price-asc"
                    })))
                }, undefined, {
                    shallow: true
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        categoryState.data,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        if (router.route == "/jewellery") {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            setIsSearch(true);
            if (((ref = router.query) === null || ref === void 0 ? void 0 : ref.fastDelivery) || ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.try_it_online) || ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.sort) || ((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.occasion) || ((ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4.metal) || ((ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.priceMax) || ((ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.priceMin)) {
                var ref7, ref8;
                dispatch((0,category/* fetchCategoryFiltersByIdWizzy */.DO)({
                    query: {
                        search: router.query.q,
                        tryItOnline: router.query.try_it_online,
                        filters: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, apiFilterQuery()), {
                            search: router.query.q,
                            q: router.query.q,
                            searchedKey: (ref7 = categoryState.products) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.filters) === null || ref8 === void 0 ? void 0 : ref8.searchedKey,
                            includeCategoriesFacetForPage: "true",
                            facets: [
                                {
                                    key: "purity"
                                },
                                {
                                    key: "occasions"
                                },
                                {
                                    key: "categories"
                                }, 
                            ]
                        })
                    }
                }));
            } else {
                var ref9, ref10;
                dispatch((0,category/* fetchSearchProductBywizzy */.EX)({
                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, apiFilterQuery()), {
                        search: router.query.q,
                        q: router.query.q,
                        searchedKey: (ref9 = categoryState.products) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.filters) === null || ref10 === void 0 ? void 0 : ref10.searchedKey
                    })
                }));
            }
        } else {
            if (categoryState.data) {
                if (!router.query.sort && [
                    "bangle-utsav-collection-2023"
                ].includes(categoryState.data.slug)) {
                    var ref11;
                    router.replace({
                        pathname: "/jewellery/category/[category]",
                        query: (0,_object_spread/* default */.Z)({
                            category: (ref11 = categoryState.data) === null || ref11 === void 0 ? void 0 : ref11.slug
                        }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                            sort: "price-asc"
                        })))
                    }, undefined, {
                        shallow: true
                    });
                } else {
                    var ref12;
                    dispatch((0,category/* fetchCategoryFiltersByIdWizzy */.DO)({
                        query: {
                            tryItOnline: router.query.try_it_online,
                            filters: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, apiFilterQuery()), {
                                categories: [
                                    String((ref12 = categoryState.data) === null || ref12 === void 0 ? void 0 : ref12.id)
                                ],
                                includeCategoriesFacetForPage: "true",
                                facets: [
                                    {
                                        key: "purity"
                                    },
                                    {
                                        key: "occasions"
                                    },
                                    {
                                        key: "categories"
                                    }, 
                                ]
                            })
                        }
                    }));
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (ref = router.query) === null || ref === void 0 ? void 0 : ref.fastDelivery,
        (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.try_it_online,
        (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.sort,
        (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.occasion,
        (ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4.metal,
        (ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.priceMax,
        (ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.priceMin,
        router.query.q,
        router.query.category, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row g-3",
                children: [
                    categoryState.productsLoading && new Array(8).fill(1).map(function(_, k) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card_skeleton/* default */.Z, {})
                        }, k);
                    }),
                    ((ref7 = categoryState.products) === null || ref7 === void 0 ? void 0 : ref7.result) && categoryState.products.result.map(function(product, index) {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                index == 10 && ((ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.inner_banner_1) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-6 col-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((product_list_module_default()).position_relative, " ").concat((product_list_module_default()).w_100, " ").concat((product_list_module_default()).custom_height_list, " ").concat((product_list_module_default()).h_100),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref1 = categoryState.data) === null || ref1 === void 0 ? void 0 : ref1.inner_banner_1,
                                            layout: "fill",
                                            alt: "Inner banner 1",
                                            priority: true,
                                            width: 696,
                                            height: 589,
                                            sizes: "(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                index == 18 && ((ref2 = categoryState.data) === null || ref2 === void 0 ? void 0 : ref2.inner_banner_2) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-6 col-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((product_list_module_default()).position_relative, " ").concat((product_list_module_default()).w_100, " ").concat((product_list_module_default()).custom_height_list, " ").concat((product_list_module_default()).h_100),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref3 = categoryState.data) === null || ref3 === void 0 ? void 0 : ref3.inner_banner_2,
                                            layout: "fill",
                                            alt: "Inner banner 1",
                                            priority: true,
                                            width: 696,
                                            height: 589,
                                            sizes: "(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                index == 30 && ((ref4 = categoryState.data) === null || ref4 === void 0 ? void 0 : ref4.inner_banner_3) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-6 col-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((product_list_module_default()).position_relative, " ").concat((product_list_module_default()).w_100, " ").concat((product_list_module_default()).custom_height_list, " ").concat((product_list_module_default()).h_100),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref5 = categoryState.data) === null || ref5 === void 0 ? void 0 : ref5.inner_banner_3,
                                            layout: "fill",
                                            alt: "Inner banner 1",
                                            priority: true,
                                            width: 696,
                                            height: 589,
                                            sizes: "(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                index == 38 && ((ref6 = categoryState.data) === null || ref6 === void 0 ? void 0 : ref6.inner_banner_4) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-6 col-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((product_list_module_default()).position_relative, " ").concat((product_list_module_default()).w_100, " ").concat((product_list_module_default()).custom_height_list, " ").concat((product_list_module_default()).h_100),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref7 = categoryState.data) === null || ref7 === void 0 ? void 0 : ref7.inner_banner_4,
                                            layout: "fill",
                                            alt: "Inner banner 1",
                                            priority: true,
                                            width: 696,
                                            height: 589,
                                            sizes: "(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 col-lg-3 col-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card, {
                                        product: product
                                    })
                                })
                            ]
                        }, product.id);
                    }),
                    !((ref8 = categoryState.products) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.result) === null || ref9 === void 0 ? void 0 : ref9.length) && !categoryState.productsLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-center",
                        children: "No records found"
                    })
                ]
            }),
            categoryState.products && ((ref10 = categoryState.products) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.result) === null || ref11 === void 0 ? void 0 : ref11.length) < ((ref12 = categoryState.products) === null || ref12 === void 0 ? void 0 : ref12.total) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: sentinelRef,
                style: {
                    height: "40px",
                    margin: "20px 0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: loadingMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                    animation: "border",
                    role: "status",
                    style: {
                        color: "rgb(143, 0, 6)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (product_list_module_default()).show_contant,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination_counter/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row mb-4 mt-4 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (product_list_module_default()).breadcrumb_main,
                                    children: !isSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4 text-md-end text-center mt-3 mt-md-0"
                            })
                        ]
                    }),
                    !!((ref13 = categoryState.data) === null || ref13 === void 0 ? void 0 : ref13.content) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (product_list_module_default()).product_list_contant,
                                children: [
                                    !!categoryState.data.content.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (product_list_module_default()).product_heading_text,
                                        children: categoryState.data.content.title
                                    }),
                                    !!categoryState.data.content.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (product_list_module_default()).product_bottomg_text,
                                        dangerouslySetInnerHTML: {
                                            __html: categoryState.data.content.description.replace(/nofollow/g, "").replace(/noopener/g, "").replace(/noreferrer/g, "")
                                        }
                                    })
                                ]
                            }),
                            !!((ref14 = categoryState.data.content.items) === null || ref14 === void 0 ? void 0 : ref14.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (product_list_module_default()).accordion_container,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                    defaultActiveKey: "0",
                                    children: categoryState.data.content.items.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Item */.Z.Item, {
                                            eventKey: "".concat(index),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Header */.Z.Header, {
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Body */.Z.Body, {
                                                    dangerouslySetInnerHTML: {
                                                        __html: item.description.replace(/nofollow/g, "").replace(/noopener/g, "").replace(/noreferrer/g, "")
                                                    }
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var products_list = (CategoryProductsListWizzy);


/***/ }),

/***/ 66091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loading_spinner_small; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/svg/spin-small.svg
/* harmony default export */ var spin_small = ({"src":"/_next/static/media/spin-small.fe64ddc1.svg","height":14,"width":14});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/common/loading-spinner-small.tsx




var LoadingSpinnerSmall = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: spin_small,
        alt: "Spinner"
    });
};
/* harmony default export */ var loading_spinner_small = (LoadingSpinnerSmall);


/***/ }),

/***/ 74043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loading_spinner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/svg/spin.svg
/* harmony default export */ var spin = ({"src":"/_next/static/media/spin.c4626fe5.svg","height":35,"width":35});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/common/loading-spinner.tsx




var LoadingSpinner = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: spin,
        alt: "Spinner"
    });
};
/* harmony default export */ var loading_spinner = (LoadingSpinner);


/***/ }),

/***/ 35098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84849);
/* harmony import */ var _styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79356);
/* harmony import */ var _styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var ProductCardSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default().product),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default().pad_10),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        style: {
                            width: 100
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        style: {
                            width: 200
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        style: {
                            marginTop: 30,
                            height: 230
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        style: {
                            marginTop: 20,
                            width: 150
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default().product_details),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default().pad_10),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        style: {
                            width: 150
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCardSkeleton);


/***/ }),

/***/ 78513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ S3ImageLoader; }
/* harmony export */ });
var S3ImageLoader = function(param) {
    var src = param.src, width = param.width;
    var url = new URL(src);
    var path = url.pathname;
    if (path.startsWith("/")) {
        path = path.substring(1);
    }
    return "https://web.sencogoldanddiamonds.com/images/transform?key=".concat(path, "&width=").concat(width, "&format=webp");
};


/***/ }),

/***/ 68320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ syteTrackEvent; }
/* harmony export */ });
var syteTrackEvent = function(data) {
    var maxRetries = 20;
    var retryCount = 0;
    var eventPushed = false;
    var intervalId;
    var tryPushEvent = function() {
        if (window.syteDataLayer) {
            window.syteDataLayer.push(data);
            clearInterval(intervalId);
            eventPushed = true;
        } else {
            retryCount++;
            if (retryCount >= maxRetries) {
                clearInterval(intervalId);
                if (!eventPushed) {
                    ;
                }
            }
        }
    };
    tryPushEvent();
    if (!eventPushed) {
        intervalId = setInterval(tryPushEvent, 1000);
    }
};


/***/ }),

/***/ 48825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ combineCategoryFilters; }
/* harmony export */ });
var combineCategoryFilters = function(query) {
    var data = {};
    if (query.priceMin) {
        data["priceMin"] = query.priceMin;
    }
    if (query.priceMax) {
        data["priceMax"] = query.priceMax;
    }
    if (query.metal) {
        data["metal"] = query.metal;
    }
    if (query.size) {
        data["size"] = query.size;
    }
    if (query.occasion) {
        data["occasion"] = query.occasion;
    }
    if (query.fastDelivery) {
        data["fastDelivery"] = query.fastDelivery;
    }
    if (query.try_it_online) {
        data["try_it_online"] = query.try_it_online;
    }
    if (query.sort) {
        data["sort"] = query.sort;
    }
    return data;
};


/***/ }),

/***/ 91920:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"checkbox-dropdown_select__Ick_2","dropdown":"checkbox-dropdown_dropdown__6vgPP"};

/***/ }),

/***/ 38606:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"single-dropdown_select__lHiO1","label":"single-dropdown_label__E5fIg","dropdown":"single-dropdown_dropdown__dp6Fl","child":"single-dropdown_child__P59Kn"};

/***/ }),

/***/ 79356:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading_list_page":"product_list_heading_list_page__tv57o","product_section":"product_list_product_section__Z8aI4","product_image":"product_list_product_image__MWkK7","products_text_top":"product_list_products_text_top__7CYdg","largimg":"product_list_largimg__xDTqQ","view_all":"product_list_view_all__jRums","filter_section":"product_list_filter_section__E9nYU","select":"product_list_select__wVQTA","select1":"product_list_select1__tHA_L","filter_section1":"product_list_filter_section1__8bnWW","check":"product_list_check__8qQyo","filter_section2":"product_list_filter_section2__04XBD","f-wrap":"product_list_f-wrap__TGInW","product":"product_list_product__usDyh","pad_10":"product_list_pad_10__TrJ0G","product_top_left":"product_list_product_top_left__X0fek","best_seller":"product_list_best_seller__qJ8Ky","trending":"product_list_trending__Fe7JU","popular":"product_list_popular__V4ju2","new_arrival":"product_list_new_arrival__edD_l","discount":"product_list_discount__OfNpr","text":"product_list_text__AAbbK","cart_top":"product_list_cart_top__ZlluG","fast_delivery":"product_list_fast_delivery__6yP8Z","price_cart":"product_list_price_cart__oHYRG","price1":"product_list_price1__PjOwc","price2":"product_list_price2___bC8n","details":"product_list_details__K7CbA","product_details":"product_list_product_details__P3jH7","product_details_text":"product_list_product_details_text__YMxEZ","find_similar":"product_list_find_similar__RlpPp","product_details_full":"product_list_product_details_full__Mi9KH","custom_row":"product_list_custom_row__4wdVk","col_4":"product_list_col_4__yxuQw","product-3":"product_list_product-3__OVyFL","product4":"product_list_product4__b8cUh","wishlist":"product_list_wishlist__UGSE_","cart":"product_list_cart__JkiNl","price":"product_list_price__Mm26N","product1":"product_list_product1__donfc","checkbox":"product_list_checkbox__ZLTE4","fast":"product_list_fast__xgFcS","view_all1":"product_list_view_all1__tvR7i","position_relative":"product_list_position_relative___h76b","w_100":"product_list_w_100__BmcHJ","custom_height_list":"product_list_custom_height_list__ziHE2","select2":"product_list_select2__b25Bu","bg_slider":"product_list_bg_slider__YxDel","show_contant":"product_list_show_contant__ka6j5","more_show":"product_list_more_show___yKez","backtotop":"product_list_backtotop__gFWy2","resent_search":"product_list_resent_search__QpQGJ","col_2":"product_list_col_2__uiL5R","card_body":"product_list_card_body__b5r7x","mobile_filter":"product_list_mobile_filter__zMDg0","desktop_filter":"product_list_desktop_filter__qjIsN","breadcrumb_main":"product_list_breadcrumb_main__lS8M5","product_text_d":"product_list_product_text_d__OKXra","banner":"product_list_banner__aAljT","tryontext":"product_list_tryontext__ij6SD","similar_button":"product_list_similar_button__77HJU","similar_button_mobile":"product_list_similar_button_mobile__nb7EC","live_banner_image":"product_list_live_banner_image__96g_O","product_list_contant":"product_list_product_list_contant__Wt8K1","product_heading_text":"product_list_product_heading_text__zpI10","product_bottomg_text":"product_list_product_bottomg_text__n8X8l","accordion_container":"product_list_accordion_container__YpN0x","accordion-button":"product_list_accordion-button__73fND","collapsed":"product_list_collapsed__M9fhH","mobile_view":"product_list_mobile_view__CwSnq","similar_modal":"product_list_similar_modal__GXd4N","sidebar_left":"product_list_sidebar_left__X7dcM","heading":"product_list_heading__oKLcQ","sidebar_image":"product_list_sidebar_image__AFtsp","overlay":"product_list_overlay__RZlXf","accordion":"product_list_accordion__TB91S","header_model":"product_list_header_model__iC2xz","product_no":"product_list_product_no__4OiLh","right_side":"product_list_right_side___5_qp","product_list_model_new":"product_list_product_list_model_new__MRRSq","filters_button_model":"product_list_filters_button_model__I0Pql","sidebar_nav":"product_list_sidebar_nav__CnxUF","open":"product_list_open__lBUIX","header":"product_list_header__kPfgV","menu":"product_list_menu__Qqvam","toggleBtn":"product_list_toggleBtn__bWAfQ","overlay_sidebar":"product_list_overlay_sidebar__59SRn","mobile_view_model":"product_list_mobile_view_model__a5JfX","accordions_senco":"product_list_accordions_senco__V_NvN","item":"product_list_item__zpIm2","arrow":"product_list_arrow__5lH0p","content":"product_list_content__pmGzn"};

/***/ })

}]);